module.exports = __webpack_public_path__ + "img/2023.6cdacfaa.png";